import React from "react";
import classNames from "classnames";
import { IWellbeingTextDisplay } from "@interfaces/Components";
import sanitizeHTML from "./helpers/sanitizeHTML";

const WellbeingTextDisplay: React.FC<IWellbeingTextDisplay> = (props) => {
  const value = props.wellbeingPart["Linked Key"]
    ? props.evidenceJSON[props.wellbeingPart["Linked Key"]]
    : "Not entered.";

  return (
    <div className="rounded-[5px] p-4 bg-white mx-4 my-1.5">
      <div className="text-acc-14px font-acc-600 text-grey-80 text-left">{props.wellbeingPart["Display Title"]}</div>
      <div
        className={classNames(
          "text-left [&>p]:!text-acc-13px [&>p]:!font-acc-normal [&>p]:!text-grey-80 mt-5",
          "[&>ul]:!text-acc-13px [&>ul]:list-disc [&>ul]:list-inside [&>ul]:pl-0",
          "[&>ol]:!text-acc-13px [&>ol]:list-decimal [&>ol]:list-inside [&>ol]:pl-0",
          "[&>li]:!text-acc-13px [&>li]:!text-grey-80"
        )}
        dangerouslySetInnerHTML={sanitizeHTML(value ?? "<p>Not entered.</p>")}
      />
    </div>
  );
};

export default WellbeingTextDisplay;
